module.exports = __webpack_public_path__ + "img/avatar1.99d0e7b1.png";